function scrollTo(elem, style, unit, from, to, time, prop) {
  if (!elem) {
    return
  }

  const start = new Date().getTime()

  const timer = setInterval(() => {
    const step = Math.min(1, (new Date().getTime() - start) / time)

    if (prop) {
      elem[style] = (from + step * (to - from)) + unit
    } else {
      elem.style[style] = (from + step * (to - from)) + unit
    }

    if (step === 1) {
      clearInterval(timer)
    }
  }, 25)

  if (prop) {
    elem[style] = from + unit
  } else {
    elem.style[style] = from + unit
  }
}

const anchors = document.querySelectorAll('.anchor')

for (let i = 0; i < anchors.length; i++) {
  anchors[i].addEventListener('click', (e) => {
    const id = e.target.getAttribute('href')
    const section = document.querySelector(id)

    scrollTo(document.scrollingElement || document.documentElement, 'scrollTop', '', document.documentElement.scrollTop, section.offsetTop - 50, 400, true)

    anchors.forEach(node => {
      node.classList.remove('text-blue-400')
    })
    e.target.classList.add('text-blue-400')

    e.preventDefault()
  }, false)
}

const menu = document.getElementsByClassName('hero-menu')[0]

window.addEventListener('scroll', () => {
  let sticky = window.scrollY > menu.getBoundingClientRect().height

  if (sticky) {
    menu.classList.add('hero-menu--sticky')
  } else {
    menu.classList.remove('hero-menu--sticky')
  }

  const menuItems = document.querySelectorAll('.hero-menu-items a')

  for (let i = 0; i < menuItems.length; i++) {
    menuItems[i].classList.remove('text-blue-400')
  }

  let active = '#section1'
  const section1 = document.getElementById('section1')
  const section2 = document.getElementById('section2')
  const section3 = document.getElementById('section3')
  const section4 = document.getElementById('section4')

  if (section1.getBoundingClientRect().top <= 70) {
    active = '#section1'
  }
  if (section2.getBoundingClientRect().top <= 70) {
    active = '#section2'
  }
  if (section3.getBoundingClientRect().top <= 70) {
    active = '#section3'
  }
  if (section4.getBoundingClientRect().top <= 70) {
    active = '#section4'
  }

  let activeItem = document.querySelectorAll('a[href^="' + active + '"]')[0]
  activeItem.classList.add('text-blue-400')
})
